import React from 'react';
import {connect} from 'react-redux';
import {Modal, Row, Col, Spin, Form, InputNumber, Radio, message} from 'antd';
import {Select, Input} from 'antd';
import {actions, asyncAdd, asyncUpdate, asyncList, asyncAreaList, asyncDeviceTagList} from './reducers';
import {formItemLayout, formatFormData} from './utils';
import DeviceTagCondition from './components/DeviceTagCondition.js'

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class Edit extends React.Component {


    componentDidMount() {
        this.props.asyncAreaList();
        this.props.asyncDeviceTagList();
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId('');
    };

    handleOk = () => {
        const {item = {}} = this.props;
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                delete values.errorInfos;
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                let temp = formatFormData(values);
                if (typeof temp.deviceType === 'undefined') {
                    temp.deviceType = 0;
                }
                if (typeof temp.areaFlag === 'undefined') {
                    temp.areaFlag = 0;
                }
                if (item.id) {
                    // 修改
                    temp.id = item.id;
                    await this.props.asyncUpdate(temp);
                } else {
                    // 添加
                    await this.props.asyncAdd(temp);
                }
                message.success('索引生成中,请刷新查询索引生成进行!');

                setTimeout(() => {
                    this.props.asyncList();
                    this.props.form.resetFields();
                    this.props.modalHide();
                    this.props.changeCurrentSelectId('');
                }, 200);
            }
        });
    };


    render() {
        const {isModalShow, isLoading, item = {}, areaData, deviceTagData} = this.props;

        console.log(item)
        const {getFieldDecorator} = this.props.form;

        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="设备前缀名称">
                            {getFieldDecorator('devicePrefixName', {
                                initialValue: item.devicePrefixName || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入设备前缀名称',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{width: '100%'}} disabled={item.devicePrefixName}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="设备类型">
                            {getFieldDecorator('deviceType', {
                                initialValue: item.deviceType,
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择设备类型',
                                    },
                                ],
                            })(
                                <Select
                                    placeholder="请选择设备类型"
                                    disabled={item.devicePrefixName}
                                >
                                    <Option value={0}>全部</Option>
                                    <Option value={1}>安卓</Option>
                                    <Option value={2}>IOS</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    {item.total && <Col span={24}>
                        <FormItem {...formItemLayout} label="总数">
                            {getFieldDecorator('total', {
                                initialValue: item.total || '',
                                rules: [],
                            })(
                                <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                             placeholder="总条数" style={{width: '100%'}} disabled={true}/>,
                            )}
                        </FormItem>
                    </Col>}
                    {item.totalCurNum && <Col span={24}>
                        <FormItem {...formItemLayout} label="总生成数">
                            {getFieldDecorator('totalCurNum', {
                                initialValue: item.totalCurNum || '',
                                rules: [],
                            })(
                                <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                             placeholder="请填写" style={{width: '100%'}} disabled={true}/>,
                            )}
                        </FormItem>
                    </Col>}

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="计划生成数">
                            {getFieldDecorator('generateSize', {
                                initialValue: item.generateSize || '',
                                rules: [],
                            })(
                                <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                             min={1} placeholder="请填写" style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    {item.curNum && <Col span={24}>
                        <FormItem {...formItemLayout} label="生成数">
                            {getFieldDecorator('curNum', {
                                initialValue: item.curNum || '',
                                rules: [],
                            })(
                                <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                             placeholder="请填写" style={{width: '100%'}} disabled={true}/>,
                            )}
                        </FormItem>
                    </Col>}
                    {item.actNum && <Col span={24}>
                        <FormItem {...formItemLayout} label="实际生成数">
                            {getFieldDecorator('actNum', {
                                initialValue: item.actNum || '',
                                rules: [],
                            })(
                                <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                             placeholder="请填写" style={{width: '100%'}} disabled={true}/>,
                            )}
                        </FormItem>
                    </Col>}

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="地区筛选标识">
                            {getFieldDecorator('areaFlag', {
                                initialValue: item.areaFlag || 1,
                                rules: [],
                            })(
                                <RadioGroup disabled={item.devicePrefixName}>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="设备地区">
                            {getFieldDecorator('areaIds', {
                                initialValue: item.areaIds || [],
                                rules: [],
                            })(
                                <Select
                                    multiple
                                    placeholder="请选择设备的地区"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    disabled={item.devicePrefixName}
                                >
                                    {areaData.map((area, index) => {
                                        return (
                                            <Option key={area.id} title={area.name} value={area.id}>
                                                {area.name}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    {/*<Col span={24}>*/}
                    {/*    <FormItem {...formItemLayout} label="排除设备地区">*/}
                    {/*        {getFieldDecorator('excludeAreaIds', {*/}
                    {/*            initialValue: item.excludeAreaIds || [],*/}
                    {/*            rules: [],*/}
                    {/*        })(*/}
                    {/*            <Select*/}
                    {/*                multiple*/}
                    {/*                placeholder="请选择设备排除的地区"*/}
                    {/*                allowClear*/}
                    {/*                optionFilterProp="children"*/}
                    {/*                filterOption={(input, option) =>*/}
                    {/*                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0*/}
                    {/*                }>*/}
                    {/*                {areaData.map((area, index) => {*/}
                    {/*                    return (*/}
                    {/*                        <Option key={area.id} title={area.name} value={area.id}>*/}
                    {/*                            {area.name}*/}
                    {/*                        </Option>*/}
                    {/*                    );*/}
                    {/*                })}*/}
                    {/*            </Select>,*/}
                    {/*        )}*/}
                    {/*    </FormItem>*/}
                    {/*</Col>*/}

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="条件标签">
                            {getFieldDecorator('tagConditions', {
                                initialValue: (item.tagConditions && item.tagConditions.length > 0) ? item.tagConditions : [{
                                    tagName: deviceTagData.length > 0 ? deviceTagData[0].k : '',
                                    condition: 0,
                                    tagValues: []
                                },],
                                rules: [],
                            })(
                                <DeviceTagCondition deviceTagData={this.props.deviceTagData} disabled={item.devicePrefixName}/>,
                            )}
                        </FormItem>
                    </Col>

                    {item.errorInfos && <Col span={24}>
                        <FormItem {...formItemLayout} label="异常信息">
                            {getFieldDecorator('errorInfos', {
                                initialValue: JSON.stringify(item.errorInfos),
                                rules: [],
                            })(
                                <Input.TextArea placeholder="异常信息" autosize={{minRows: 4, maxRows: 12}}
                                                style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>}


                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title={item.id ? "继续生成" : "生成索引"}
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.deviceIndex.list.reduce((a, b) => (b.id === state.deviceIndex.currentSelectId ? b : a), {}),
    isModalShow: state.deviceIndex.uiStatus.isUpdateShow,
    isLoading: state.deviceIndex.uiStatus.isLoading,
    areaData: state.deviceIndex.areaData,
    deviceTagData: state.deviceIndex.deviceTagData,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({isUpdateShow: false})),
    asyncAdd: (contents) => dispatch(asyncAdd(contents)),
    asyncUpdate: (contents) => dispatch(asyncUpdate(contents)),
    asyncList: () => dispatch(asyncList()),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    asyncAreaList: () => dispatch(asyncAreaList()),
    asyncDeviceTagList: () => dispatch(asyncDeviceTagList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/assist/deviceIndex/edit.js